import { changeLang } from "@/app/appSlice"
import { RootState } from "@/app/store"

export default function LangSelector() {
  const dispatch = useAppDispatch()
  const lang = useAppSelector((state: RootState) => state.app.lang)

  const langSelector = availableLang.map((l, li) => {
    return (
      <button
        className={clsx({
          // "mr-2": li !== availableLang.length - 1,
          lang: true,
          white: lang !== l.code,
        })}
        //

        onClick={() => dispatch(changeLang(l.code))}
        key={l.code}
      >
        {l.display}
      </button>
    )
  })

  return <div>{langSelector}</div>
}
